import React from 'react';
import DataTable from 'react-data-table-component';
import { Address } from '../../interfaces/user';

interface Props {
  addresses: Address[];
  search: string;
  onSearchChange: (val: string) => void;
  loading: boolean;
}

const addressColumns = [
  { name: 'City', selector: (row: Address) => row.city, sortable: true },
  { name: 'State', selector: (row: Address) => row.state || '-', sortable: true },
  { name: 'Country', selector: (row: Address) => row.country, sortable: true },
  { name: 'Postal Code', selector: (row: Address) => row.postalCode || '-', sortable: true },
  {
    name: 'Default',
    cell: (row: Address) =>
      row.isDefault ? <span className="badge bg-success">Default</span> : <span className="badge bg-secondary">No</span>,
    sortable: true,
  },
];

const AddressTable: React.FC<Props> = ({ addresses, search, onSearchChange, loading }) => {
  const filtered = addresses.filter(address =>
    address.city.toLowerCase().includes(search.toLowerCase()) ||
    (address.state?.toLowerCase().includes(search.toLowerCase())) ||
    address.country.toLowerCase().includes(search.toLowerCase())
  );

  return (
    // <div className="card mb-4">
    //   <div className="card-header bg-primary text-white">
    //     <h3 className="mb-0">Addresses</h3>
    //   </div>
      <div className="card-body">
        {loading ? (
          <div className="text-center py-4">Loading addresses...</div>
        ) : (
          <DataTable
            columns={addressColumns}
            data={filtered}
            pagination
            subHeader
            paginationPerPage={5}
            subHeaderComponent={
              <input
                type="text"
                placeholder="Search addresses..."
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                className="form-control"
              />
            }
          />
        )}
      </div>
    // </div>
  );
};

export default AddressTable;
